import React from 'react';
import t from '@jetshop/intl';
import { elementPressAnimation } from '../../../ui/animations/elementPressAnimation';

import { styled } from 'linaria/react';
import { theme } from '../../../Theme';

const AutoCorrectWrapper = styled('div')`
  --button-light-grey: #e7e8e9;
  --button-dark-grey: #555;

  margin-top: 4px !important;

  span {
    font-weight: 600;
  }

  h1 {
    font-size: 32px;
    font-weight: 400;
    line-height: 112%;
    span {
      font-weight: 600;
      text-transform: capitalize;
    }

    ${theme.below.lg} {
      font-size: 24px;
    }
  }

  button {
    display: inline-block;
    padding: 6px 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: none;
    background: var(--button-light-grey);
    color: var(--button-dark-grey);
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    animation: fadeInScaleUp 0.3s ease-out forwards;
    text-transform: capitalize;

    &:hover {
      background: var(--button-dark-grey);
      color: var(--button-light-grey);
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
    }

    &:active {
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }
  }
`;

export const ElevateAutoCorrect = ({ autoCorrect, term, clickCallback }) => {
  const correctedTerm = autoCorrect?.q;

  if (!correctedTerm) {
    return null;
  }

  if (correctedTerm !== term) {
    return (
      <AutoCorrectWrapper className="autocorrect">
        {t.rich('Search instead for {term}', {
          term: (
            <button
              className={elementPressAnimation}
              onClick={() => clickCallback(term)}
            >
              {term}
            </button>
          )
        })}
      </AutoCorrectWrapper>
    );
  }

  return null;
};
